import { render, staticRenderFns } from "./SelectCareers.vue?vue&type=template&id=72051655&"
import script from "./SelectCareers.vue?vue&type=script&lang=js&"
export * from "./SelectCareers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports